module.exports = __webpack_public_path__ + "res/12-img_game_top.289fcf9263176427de07c991aa9ec747.png";